<app-header></app-header>
<!-- <app-user-login></app-user-login>
<app-test-list *ngIf="authenticationService.userData"></app-test-list> -->
<router-outlet></router-outlet>
<app-footer></app-footer>